<script setup lang="ts">
const config = useRuntimeConfig()
const component = 'script'
</script>

<template>
  <slot />
  <component
    :is="component"
    v-if="config.public.reviveId && config.public.reviveScriptUrl"
    :src="config.public.reviveScriptUrl"
    async
  />
</template>
